/**
 * Page bundle for `bahelastruk-touch` — the Cikstik iPad karcis.
 *
 * Same flow, same file, different profile. Everything that actually differs
 * lives in `karcisVariant.ts`; this exists only so `customRoutes` has a second
 * page map to point at. Forking Welcome.tsx would have been the obvious move
 * and the wrong one — it is 1,400 lines that have taken six rounds of field
 * fixes, and a copy would need every seventh one applied twice.
 */

import React from 'react'
import BahelaReceiptPage from './Welcome'
import { KARCIS_TOUCH } from './karcisVariant'

export const Welcome: React.FC = () => <BahelaReceiptPage variant={KARCIS_TOUCH} />
